import BackgroundDark from 'components/BackgroundImage/BackgroundDark';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getLocation, setLocation } from 'reducer/location';
import styled, { css, keyframes } from 'styled-components';

const FADE_TO_BLACK = 1;
const FADE_FROM_BLACk = 2;

const fadeToBlackAndBack = keyframes`
  0% {
    opacity: 0;
  }
 100% {
    opacity: 1;
  }
`;

const fadeToBlackAnimation = css`
  animation: ${fadeToBlackAndBack} 0.5s ease-in 1;
`;

const fadeFromBlack = keyframes`
  0% {
    opacity: 1;
  }
 100% {
    opacity: 0;
  }
`;
const fadeFromBlackAnimation = css`
  animation: ${fadeFromBlack} 0.5s ease-in;
`;

const getAnimation = ({ animationState }) => {
  switch (animationState) {
    case FADE_TO_BLACK:
      return fadeToBlackAnimation;
    case FADE_FROM_BLACk:
      return fadeFromBlackAnimation;
    default:
      return null;
  }
};

const Transition = styled(BackgroundDark)`
  filter: brightness(70%);
  background-color: white;
  z-index: 100;
  pointer-events: none;
  width: 140%;
  opacity: 0;
  ${getAnimation}
  // large
  @media (min-width: 1400px) {
    width: 100%;
  }
  pointer-events: none;
`;

// isNight is required for updates everything else passed in are just dependencies and BackgroundTransitions will watch for changes to them
const BackgroundTransitions = () => {
  const dispatch = useDispatch();
  const { location } = useHistory();
  const locationRef = useSelector(getLocation);
  const [animationState, setAnimationState] = useState(null);
  useEffect(() => {
    if (location.pathname !== locationRef.pathname) {
      setAnimationState(FADE_TO_BLACK);
    }
  }, [dispatch, location, locationRef]);
  return (
    <Transition
      animationState={animationState}
      onAnimationEnd={() =>
        setAnimationState((animationState) => {
          if (animationState === FADE_TO_BLACK) {
            dispatch(setLocation(location));
            return FADE_FROM_BLACk;
          }
          return null;
        })
      }
    />
  );
};
export default BackgroundTransitions;
